//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'FeaturedInList',
  components: {
    BaseImg: () => import('@motionelements/core/src/components/ui/BaseImg.vue'),
  },
  data() {
    return {
      featuredInList: [
        {
          logo: 'logo-techinasia',
          title: 'Tech In Asia',
        },
        {
          logo: 'logo-e27',
          title: 'e27',
        },
        {
          logo: 'logo-thebridge',
          title: 'The Bridge',
        },
        {
          logo: 'logo-dexigner',
          title: 'Dexigner',
        },
        {
          logo: 'logo-businesstimes',
          title: 'The Business Times',
        },
        {
          logo: 'logo-platum',
          title: 'Platum',
        },
        {
          logo: 'logo-asahi',
          title: 'Asahi Shimbun Digital',
        },
        {
          logo: 'logo-besuccess',
          title: 'beSUCCESS',
        },
        {
          logo: 'logo-venturesquare',
          title: 'Venture Square',
        },
      ],
    };
  },
};
